import React, { useEffect, useState } from 'react'
import { Input, Table } from "antd";
import StyledPeoplePage from "../../../Pages/Settings/People/style";
import { SearchOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { useSelector } from "react-redux";
import FetchData from "../../../../hooks/FetchData";
import moment from "moment";

// Styled Component Container for all sections
const Customstyle = styled.div`
 text-align:left;
  `;

function Activitylog() {
    const clientId = useSelector((state) => state.authTracking.userInfo.clientId);
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
      if (!clientId) return;
      setLoading(true);
      FetchData({ endPoint: `/report/getactivitylog/${clientId}` })
        .then((res) => setLogs(res?.response || []))
        .catch(() => setLogs([]))
        .finally(() => setLoading(false));
    }, [clientId]);

    const columns = [
        {
          title: "Activity Type",
          dataIndex: "activitytype",
          key: "activitytype",
        },
        {
          title: "Date & Time",
          dataIndex: "datetime",
          key: "datetime",
        },

        {
          title: "Detail",
          dataIndex: "detail",
          key: "detail",

        },
      ];

      const data = logs
        .filter((log) =>
          !searchText.trim()
            ? true
            : (log.actionLog || "").toLowerCase().includes(searchText.trim().toLowerCase()) ||
              (log.actionType || "").toLowerCase().includes(searchText.trim().toLowerCase())
        )
        .map((log) => ({
          key: log.logId,
          activitytype: log.actionType,
          datetime: log.actionDate ? moment(log.actionDate).format("Do MMM YYYY; hh:mm A") : "—",
          detail: `${log.actionLog}${log.userName ? ` by ${log.userName}` : ""}`,
        }));
  return (
    <div>
        <StyledPeoplePage>
            <Customstyle>
        <p className='activity-text'>Activity Log Report</p>
        <br/><br/>
       <div>
            <Input
              placeholder="Search"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              prefix={<SearchOutlined style={{ color: "#636980" }} />}
              className="searchbar-style"
            />
          </div>
          <br/><br/>
          <Table
                      columns={columns}
                      dataSource={data}
                      loading={loading}
                      rowClassName={(record, index) =>
                        index % 2 === 0 ? "table-row-white" : "table-row-gray"
                      }
                      className="custom-table"
                      pagination={false}
                    />
          </Customstyle>
          </StyledPeoplePage>
    </div>
  )
}

export default Activitylog
